import React from 'react';
import { Box, CardMedia, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import help from '../../assets/images/help.jpeg';

function SupportFooter() {
  const theme = useTheme();

  return (
    <Box
      style={{
        color: theme.palette.white.main,
        margin: 10,
      }}
    >
      <Typography variant="h6">Need Help?</Typography>
      <CardMedia
        component="img"
        image={help}
        style={{ borderRadius: 5 }}
      />
      <Typography variant="title1">support@aktivu.com</Typography>
      <Typography variant="caption" display="block">
        &copy; {new Date().getFullYear()} pycube.com
      </Typography>
    </Box>
  );
}

export default SupportFooter;
